import React, { useState, useEffect, useRef } from 'react';
/* eslint-disable */
import * as Yup from 'yup';

// material
import { Container } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Stack,
  TextField,
  Button,
  Grid,
  Typography,
  Card
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Service';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { trackPromise } from 'react-promise-tracker';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import _ from 'lodash';
import { LoadingComponent } from 'src/pages/pageLoader';
import SearchNotFound from '../../../SearchNotFound';
import { makeStyles } from '@material-ui/styles';
import { Autocomplete } from '@mui/material';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { AlertDialog } from './../../Common/AlertDialog';

const useStyles = makeStyles({
  table: {
    minWidth: 700
  }
});

var screenCode = 'VIEWOUTLETORDERS';

export default function ViewOutletOrders(props) {
  const [group, setGroup] = useState([]);
  const [factory, setFactory] = useState([]);
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const [date, setDate] = useState(new Date());
  const [isEnable, setIsEnable] = useState(false);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });

  const [formData, setFormData] = useState({
    groupID: 0,
    factoryID: 0,
    date: ''
  });

  const [readyToWeighmentDetails, setReadyToWeighmentDetails] = useState(0);
  const [message3, setMessage3] = useState("Ready To Weighment Confirmation");
  const [EnableConfirmMessage3, setEnableConfirmMessage3] = useState(false);
  const [selectedFactory, setSelectedFactory] = useState(null);

  const productcatogerySearchSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
    factoryID: Yup.number().min(1, 'Please Select Outlet').required('Outlet Required'),
    date: Yup.date().notRequired()
  });

  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      factoryID: formData.factoryID,
      date: formData.date
    },
    validationSchema: productcatogerySearchSchema,
    onSubmit: (values) => {
      trackPromise(SubmitForm(values));
    }
  });

  useEffect(() => {
    trackPromise(getPermissions());
  }, []);

  useEffect(() => {
    setTableData([])
  }, [formik.values.factoryID]);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find((p) => p.permissionCode == 'VIEWOUTLETORDERSSCREEN');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find((p) => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined
    });

    setValues({
      ...values,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group)
    });
    trackPromise(GetAllGroups());
  }

  useEffect(() => {
    trackPromise(GetOutletByGroupID());
  }, [formik.values.groupID]);

  useEffect(() => {
    setTableData([]);
  }, [date]);

  async function GetAllGroups() {
    var res = await services.GetAllGroups();
    if (res != null) {
      setGroup(res);
    }
  }

  async function GetOutletByGroupID() {
    var res = await services.GetOutletByGroupID(formik.values.groupID);
    if (res != null) {
      setFactory(res);
    }
  }

  async function SubmitForm(value) {
    setTableData([]);
    var result = await services.GetViewOutletOrdersDetails(formik.values.factoryID, date.toISOString());
    if (result.length > 0) {
      setIsEnable(result.filter(x => x.mobileStatusID != 1).length > 0 ? true : false)
      setTableData(result);
    }
  }

  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;
  const filterOptions = (options, { inputValue }) => {
    const trimmedInput = inputValue.trim().toLowerCase();

    const filteredOptions = options.filter(option =>
      (option.factoryName && option.factoryName.toLowerCase().includes(trimmedInput))
    ).filter(option => option.factoryName !== null);

    const exactMatchOptions = [];
    const nonExactMatchOptions = [];
    filteredOptions.forEach(option => {
      if (
        option.factoryName.toLowerCase() === trimmedInput
      ) {
        exactMatchOptions.push(option);
      } else {
        nonExactMatchOptions.push(option);
      }
    });

    // Return exact matches if any, otherwise return non-exact matches
    return exactMatchOptions.length > 0 ? exactMatchOptions : nonExactMatchOptions;
  };

  function handleSearchDropdownChange(data, e) {
    setSelectedFactory(data);
    if (data === undefined || data === null) {
      setValues({
        ...values,
        factoryID: '0'
      });
      return;
    } else {
      var value = data.factoryID;
      setValues({
        ...values,
        factoryID: value,
      });
    }
  }

  function confirmData3(y) {
    if (y) {
      trackPromise(approveReadyToWeighment(readyToWeighmentDetails))
    }
  }

  async function approveReadyToWeighment(readyToWeighmentDetails) {
    var res = await services.ApproveReadyToWeighment(readyToWeighmentDetails, date.toISOString())
    if (res.statusCode === "Success") {
      toast.success(res.message);
    } else {
      toast.error(res.message);
    }
    trackPromise(SubmitForm());
  }

  function ReadyToWeighment() {
    setEnableConfirmMessage3(true);
    setReadyToWeighmentDetails(formik.values.factoryID)
  }

  async function clearAll() {
    setValues({
      ...values,
      factoryID: 0
    });
    setTableData([]);
    setSelectedFactory(null); 
  }

  return (
    <>
      <LoadingComponent />
      <Page title="View Outlet Orders |  FAPS">
        <Container>
          <CommonPageHeader
            path={'/viewOutletOrders'}
            btname="Add"
            pageName="View Outlet Orders"
            leftButtonHidden={true}
          />

          <FormikProvider value={formik}>
            <ToastContainer position="bottom-right" pauseOnHover />
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Group *"
                    value={formik.values.groupID}
                    onChange={formik.handleChange}
                    {...getFieldProps('groupID')}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                    InputProps={{
                      readOnly: true
                    }}
                  >
                    <MenuItem key={0} value={0}>
                      Select Group
                    </MenuItem>
                    {group.map((option) =>
                      option.isActive == true ? (
                        <MenuItem key={option.groupID} value={option.groupID}>
                          {option.groupName}
                        </MenuItem>
                      ) : null
                    )}
                  </TextField>
                  <Autocomplete
                    fullWidth
                    clearOnEscape
                    id="factoryID"
                    options={factory}
                    value={selectedFactory}
                    filterOptions={filterOptions}
                    getOptionLabel={(option) => `${option.factoryName}`}
                    onChange={(e, value) => handleSearchDropdownChange(value, e)}
                    renderOption={(props, option) => (
                      <li {...props}>
                        {`${option.factoryName}`}
                      </li>
                    )}
                    renderInput={(params) =>
                      <TextField {...params}
                        variant="outlined"
                        name="factoryID"
                        label="Outlet *"
                        size="small"
                        fullWidth
                        helperText={touched.factoryID && errors.factoryID}
                        error={Boolean(touched.factoryID && errors.factoryID)}
                      />
                    }
                  />
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Select Date *"
                      value={date}
                      onChange={(newValue) => {
                        setDate(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          fullWidth
                          size="small"
                          {...getFieldProps('date')}
                          error={Boolean(touched.date && errors.date)}
                          helperText={touched.date && errors.date}
                          {...params}
                        />
                      )}
                    />
                  </LocalizationProvider>
                  <div>
                    <Button
                        type="button"
                        variant="outlined"
                        color='error'
                        onClick={() => clearAll()}
                    > Clear</Button>
                  </div>
                  <div>
                    <Button
                        type="submit"
                        color='secondary'
                        variant="outlined"
                    >Search</Button>
                </div>
                </Stack>
              </Stack>
              <br />
            </Form>
          </FormikProvider>
          <br />
          {tableData.length != 0 ? (
            <>
              <Card style={{ justifycontent: 'center', width: '100%' }}>
                <TableContainer component={Paper}>
                  <Table size='small' aria-label="collapsible table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="left" style={{ fontWeight: 'bold' }}>Outlet</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold' }}>
                          Order No
                        </TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold' }}>
                          SKU
                        </TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold' }}>
                          Crop
                        </TableCell>
                        <TableCell align="right" style={{ fontWeight: 'bold' }}>
                          Qty
                        </TableCell>
                        <TableCell align="center" style={{ fontWeight: 'bold' }}>
                          Status
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tableData.map((row) => (
                        <TableRow>
                          <TableCell align="left">{row.factoryName}</TableCell>
                          <TableCell align="left">{row.performOrderOutletWiseCode}</TableCell>
                          <TableCell align="left">{row.productCode}</TableCell>
                          <TableCell align="left">{row.productName} </TableCell>
                          <TableCell align="right">{row.quantity} </TableCell>
                          <TableCell align="center">
                            {row.mobileStatusID == 1 ? 'New' :
                              row.mobileStatusID == 2 ? 'Ready To Weighment' :
                                row.mobileStatusID == 3 ? 'Processing' :
                                  row.mobileStatusID == 4 ? 'Complete' : ''}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
              <br />
              <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                <Button type="submit" color="secondary"
                  disabled={isEnable}
                  variant="contained"
                  onClick={() => ReadyToWeighment()}>
                  Ready To Weighment
                </Button>
              </Stack>
            </>
          ) : (
            <SearchNotFound searchQuery="View Outlet Orders" />
          )}
        </Container>
      </Page>
      <div hidden={true}>
        <Grid item>
          <AlertDialog confirmData={confirmData3} headerMessage={message3} viewPopup={EnableConfirmMessage3}
            discription={"Are you sure want to approve this order ?"} setViewPopup={setEnableConfirmMessage3} />
        </Grid>
      </div>
    </>
  );
}
